import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NotFound } from "../modules/404";
import { useMe } from "../modules/users/hooks/useMe";

import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Loading } from "../components";

import { Dashboard } from "../modules/dashboard";
import { UsersRouter } from "../modules/users/users.router";

import { AdminRouter } from "./admin-router";
import { ClientRouter } from "./client-router";

import { UserRole } from "../__generated__/globalTypes";
import { ShopsRouter } from "../modules/shops/shops.router";

export const LoggedInRouter = () => {
  const { data, loading, error } = useMe();

  if (!data || loading || error) {
    return <Loading />;
  }

  if (data?.me?.role === UserRole.Admin) {
    return <AdminRouter />;
  }
  if (data?.me?.role === UserRole.Client) {
    return <ClientRouter />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {UsersRouter}
          {ShopsRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
